import React from 'react';
import styled from '@emotion/styled';

import { TextColor, ActionColor, ActionTextColor } from '../../styles/colors';

import Modebewusst from './ModebewusstSVG';

const Container = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;

  padding: 0;
  height: 310px;
  width: 310px;

  color: ${TextColor};
  background-color: none;
  border-radius: 50%;

  @media (min-width: 980px) {
    padding: 15px;
    height: 340px;
    width: 340px;

    color: ${ActionTextColor};
    background-color: ${ActionColor};
  }
`;

const HoleApplique = styled.div`
  display: block;
  width: 30px;
  height: 30px;
  background-color: ${ActionTextColor};
  border-radius: 50%;
  margin-bottom: 25px;

  @media (max-width: 979px) {
    display: none;
  }
`;

export default () => (
  <Container>
    <HoleApplique />
    <Modebewusst />
  </Container>
);



// WEBPACK FOOTER //
// ./src/components/PageHeader/Hero/Hero.js